// extracted by mini-css-extract-plugin
module.exports = {"dialog--overlay":"dialog--overlay__n8-hS"};